// src/shared/components/layout/Avatar.jsx
import * as React from 'react';
import Avatar from '@mui/material/Avatar';

/**
 * Hash a name to a stable HUE (0-359) and render as HSL with fixed
 * saturation + lightness. Every user gets a recognizable color, but every
 * color reads as the same tone and brightness — no muddy browns, no neon
 * greens, no near-black avatars that swallow the initials. Same pattern
 * used by Slack, Notion, and Google Workspace.
 *
 * Saturation 55% + lightness 50% keeps white initials legible across the
 * hue wheel (contrast ratio ~4.5:1 or better against #fff).
 */
export function stringToHslColor(string = 'User', saturation = 55, lightness = 50) {
  let hash = 0;
  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

function initials(name = 'User') {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? 'U';
  return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
}

export default function UserAvatar({ name = 'User', size = 30 }) {
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        bgcolor: stringToHslColor(name),
        color: '#fff',
        fontSize: Math.round(size * 0.4),
        fontWeight: 600,
      }}
    >
      {initials(name)}
    </Avatar>
  );
}
